
angular.module('omfm').filter("formatDate", FormatDateFilter);


FormatDateFilter.$inject = [];

function FormatDateFilter() {
	return function (inputValue, dateFormat, lang) {

		if(!angular.isString(inputValue)){
			return null;
		}
		
		var locale = 'en';
		var localeConvert = {'uk': 'ua'};
		
		lang = lang || locale;
		
		lang = localeConvert[lang] || lang;
		
		return Utilities.createDate(Utilities.parseDateString(inputValue), dateFormat, lang, false);
	}
}